import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import PlaylistList from './components/PlaylistList';
import PlaylistView from './components/PlaylistView';
import ArtistView from './components/ArtistView';
import SongView from './components/SongView';
import TopSongs from './components/TopSongs';
import TopArtists from './components/TopArtists';
import Search from './components/Search';
import Generator from './components/Generator';
import GeneratorV3 from './components/GeneratorV3';
import Library from './components/Library';
import Stats from './components/Stats';
// Services removed - functionality moved to Mission Control
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import NowPlaying from './components/NowPlaying';
import SpotifyReauthBanner from './components/SpotifyReauthBanner';
import RateForm from './components/RateForm';
import RatingsAdmin from './components/RatingsAdmin';
import TodayQR from './components/TodayQR';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isBuilderPage = location.pathname === '/builder';
  const isRatePage = location.pathname.startsWith('/rate/');
  const isTodayQrPage = location.pathname === '/qr/today';

  // /rate/:id is a public, focused, full-screen mobile experience
  // for riders coming in from the QR code. /qr/today is the instructor's
  // bookmark — also chromeless so it fills the screen when held up to a
  // class. No header, no banner, no chrome on either.
  if (isRatePage || isTodayQrPage) {
    return (
      <Routes>
        <Route path="/rate/:id" element={<RateForm />} />
        <Route path="/qr/today" element={<TodayQR />} />
      </Routes>
    );
  }

  // Builder v3 gets its own full-screen layout (no header/footer)
  if (isBuilderPage) {
    return (
      <>
        <SpotifyReauthBanner />
        <Routes>
          <Route
            path="/builder"
            element={
              <ProtectedRoute>
                <GeneratorV3 />
              </ProtectedRoute>
            }
          />
        </Routes>
      </>
    );
  }

  return (
    <div className="App">
      <SpotifyReauthBanner />
      <Header />

      <main className="app-main">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<PlaylistList />} />
          <Route path="/playlist/:id" element={<PlaylistView />} />
          <Route path="/artist/:id" element={<ArtistView />} />
          <Route path="/song/:id" element={<SongView />} />
          <Route path="/top-songs" element={<TopSongs />} />
          <Route path="/top-artists" element={<TopArtists />} />
          <Route path="/search" element={<Search />} />
          <Route path="/stats" element={<Stats />} />
          {/* Services route removed - functionality in Mission Control */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes */}
          <Route
            path="/generate"
            element={
              <ProtectedRoute>
                <Generator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/builder"
            element={
              <ProtectedRoute>
                <GeneratorV3 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/library"
            element={
              <ProtectedRoute>
                <Library />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/ratings"
            element={
              <ProtectedRoute>
                <RatingsAdmin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>

      <NowPlaying />

      <footer className="app-footer">
        <p>Powered by Spotify 🎵</p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
